import { motion } from "framer-motion";
import { Check, Lock } from "lucide-react";
import { fadeUp, viewport } from "@/components/anim";

const INCLUDES = [
  "Pre-public token airdrops to your wallet",
  "Custom MEV & sniper bot configuration",
  "Real-time Tier-1 whale tracking alerts",
  "Verified, time-stamped signal calls",
  "Private Telegram — instant access on payment",
  "Lifetime membership, one-time 2 SOL",
];

export const Pricing = ({ onJoin }) => {
  return (
    <section
      id="pricing"
      className="relative py-24 sm:py-32 bg-[#05060A] grid-bg overflow-hidden"
    >
      <div className="absolute inset-0 radial-glow pointer-events-none" />
      <div className="relative mx-auto max-w-5xl px-5 lg:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#14F195]">
            / The Gate
          </span>
          <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            One pass. Every edge. Forever.
          </h2>
        </motion.div>

        <motion.div
          data-testid="pricing-card"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="relative rounded-3xl border border-[#14f19533] glass p-8 sm:p-12 overflow-hidden"
          style={{ boxShadow: "0 40px 120px -40px rgba(20,241,149,0.35)" }}
        >
          <div className="absolute top-0 right-0 font-display font-black text-[10rem] leading-none text-[#14F195]/[0.04] pointer-events-none select-none -mr-6 -mt-6">
            X
          </div>
          <div className="grid md:grid-cols-2 gap-10 items-center relative z-10">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full border border-[#9945ff44] bg-[#9945ff14] px-3 py-1 text-xs font-mono uppercase tracking-wider text-[#c9a6ff]">
                VIP Lifetime Pass
              </span>
              <div className="mt-6 flex items-end gap-2">
                <span className="font-display font-black text-6xl sm:text-7xl text-white">2</span>
                <span className="font-display font-black text-3xl text-[#14F195] mb-2">SOL</span>
              </div>
              <p className="mt-2 font-mono text-sm text-[#64748B]">
                One-time payment · No renewals · No hidden fees
              </p>
              <button
                data-testid="pay-modal-trigger-button"
                onClick={onJoin}
                className="mt-8 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#14F195] px-7 py-4 text-base font-bold text-[#05060A] hover:bg-[#3dffb0] hover:scale-[1.02] active:scale-95 transition-transform duration-200"
              >
                <Lock className="w-5 h-5" />
                Pay 2 SOL & Unlock Telegram
              </button>
              <p className="mt-3 text-center font-mono text-[11px] text-[#64748B]">
                Invite link revealed instantly after on-chain verification
              </p>
            </div>

            <ul className="space-y-4">
              {INCLUDES.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#14f1951a] border border-[#14f19544] shrink-0">
                    <Check className="w-3 h-3 text-[#14F195]" />
                  </span>
                  <span className="text-[#cbd5e1] text-sm sm:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
